<template lang="pug">
v-card(class="mx-auto" width="100%" flat outlined)
      v-card-title.pt-0
        v-col(cols="1").d-flex.ma-0.pa-0
          slot(name="append-item-title")
          v-icon(v-if="item.type === 'Article'").pr-3 mdi-file-document-outline
          v-icon(v-if="item.type === 'Protest'").pr-3 mdi-bullhorn-outline
          v-icon(v-if="item.type === 'Activity'").pr-3 mdi-crowd
        v-col(cols="10")
          | {{ getSearchResultItemTitle(item) }}
          v-icon(v-if="isRaw(item)" color="orange" large).pl-3 mdi-raw
        v-col(cols="1" align="right")
          v-btn(
            icon
            outlined
            color="accent"
            @click="show = !show"
            )
            v-icon() {{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      v-card-subtitle 
        | Last Modified: {{formatDate(item.lastModifiedDate)}}{{ item['@search.score'] ? `, Relevance: ${item['@search.score']}` : `` }}
        a(:href="`${appConfig.VUE_APP_PORTAL_URL}portal/${getType(item.type)}s/detail/${item.id}`" target="_blank").ml-3 Portal
          v-icon(color="accent" small).ml-1 mdi-open-in-new
        a(:href="`/${getType(item.type)}s/update?${getType(item.type)}Id=${item.id}`" target="_blank").ml-3 Edit
          v-icon(color="accent" small).ml-1 mdi-text-box-edit-outline
      div(v-show="!show")
        v-card-text(v-html="item.content ? removeHTML(preview(item.content)) : ''")
        v-card-text(v-if="showRisk")
          v-row.d-flex.pa-0.ma-0
            v-col(cols="6" sm="6").pa-0.ma-0
              b Risk :&nbsp;
              | {{ getDimensionForSearchResult(item, "impact") }}
      v-expand-transition
        div(v-show="show")
          v-card-text(v-html="item.content")
          v-card-subtitle(v-if="item.sources") <b>Sources:</b> 
            a(v-for="source in item.sources" :href="source") {{ source}}
          v-card-text
            v-row.d-flex.pa-0.ma-0
              v-col(cols="6" sm="6" v-for="dimension in dimensions" :key="dimension").pa-0.ma-0
                b {{dimension === "Impact" ? "Risk" : dimension}} :&nbsp;
                | {{ getDimensionForSearchResult(item, dimension.toLowerCase()) }} 

</template>
<script>
import appConfig from "@/services/config";
import { commonMixins } from "@/mixins/common";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    showFullCard: {
      type: Boolean,
      required: false,
      default: true,
    },
    showRisk: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [commonMixins],
  data: () => ({
    appConfig: appConfig,
    show: true,
    dimensions: [
      "Sectors",
      "Groups",
      "Targets",
      "Campaigns",
      "Issues",
      "Tactic",
      "Events",
    ],
  }),
  methods: {
    // getDimension(item, dimension) {
    //   const attribute = item[dimension.toLowerCase()];

    //   if (attribute && Array.isArray(attribute)) {
    //     if (attribute.length > 0) {
    //       return attribute.join(", ");
    //     } else {
    //       return "none";
    //     }
    //   } else if (attribute && !Array.isArray(attribute)) {
    //     return attribute;
    //   } else return "none";
    // },
    getType(item) {
      if (["Protest", "Activity"].includes(item)) return "action";
      return "article";
    },
    removeHTML(input) {
      return ""
        .concat(input)
        .replace(/<[^>]*>?/gm, "")
        .replace("&nbsp;", " ")
        .replace(".", ". ");
    },
    isRaw(item) {
      return item.type === (item?.title || "").startsWith("-");
    },
    preview(content) {
      return content.substring(0, 500) + "...";
    },
  },
  created() {
    this.show = this.showFullCard;
    if (this.showRisk) {
      this.dimensions.unshift("Impact");
    }
  },
};
</script>
<style>
.card {
  margin: 5px 5px;
}
</style>
